// extracted by mini-css-extract-plugin
export default {"root":"PrivacyPolicy_root__Vr+vU","widget":"PrivacyPolicy_widget__Ol1kS"};